module.exports = __webpack_public_path__ + "static/media/logo-frontier-research.af401f86.png";